const ORG_OVERRIDE_HEADER = "X-Roboto-Org-Id";
const RESOURCE_OWNER_OVERRIDE_HEADER = "X-Roboto-Resource-Owner-Id";
const USER_OVERRIDE_HEADER = "X-Roboto-User-Id";
const API_VERSION_HEADER = "X-Roboto-Api-Version";

export function robotoHeaders(values: {
  orgId?: string;
  resourceOwnerId?: string;
  userId?: string;
  /**
   * Pin the request to a dated API version instead of the latest; the server
   * transforms the request and response to that version's shape.
   */
  apiVersion?: string;
}): Headers {
  const { orgId, resourceOwnerId, userId, apiVersion } = values;

  const headers = new Headers();

  if (apiVersion !== undefined) {
    headers.append(API_VERSION_HEADER, apiVersion);
  }

  if (orgId !== undefined) {
    headers.append(ORG_OVERRIDE_HEADER, orgId);
  }
  if (resourceOwnerId !== undefined) {
    headers.append(RESOURCE_OWNER_OVERRIDE_HEADER, resourceOwnerId);
  }
  if (userId !== undefined) {
    headers.append(USER_OVERRIDE_HEADER, userId);
  }

  return headers;
}
